var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgTele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.912,
    height: 28.087,
    viewBox: "0 0 15.912 28.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M14.912,0H0",
    transform: "translate(0 22.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "M.287.294A.291.291,0,0,1,0,0",
    transform: "translate(7.169 24.732)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    className: "cls-1",
    width: 14.912,
    height: 27.087,
    rx: 2,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-1",
    d: "M10.324,4.122a.581.581,0,0,0-.574-.589H6.883V.589A.581.581,0,0,0,6.309,0H4.015a.581.581,0,0,0-.574.589V3.533H.574A.581.581,0,0,0,0,4.122V6.477a.581.581,0,0,0,.574.589H3.441V10.01a.581.581,0,0,0,.574.589H6.309a.581.581,0,0,0,.574-.589V7.066H9.75a.581.581,0,0,0,.574-.589Z",
    transform: "translate(2.294 5.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-1",
    d: "M.287,0A.291.291,0,0,1,0,.294",
    transform: "translate(7.456 24.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-1",
    d: "M0,0A.291.291,0,0,1,.287.294",
    transform: "translate(7.456 24.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "cls-1",
    d: "M0,.294A.291.291,0,0,1,.287,0",
    transform: "translate(7.169 24.437)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTele);
export default __webpack_public_path__ + "static/media/imgTele.be63fc6192cf350237b6190e64daa4bf.svg";
export { ForwardRef as ReactComponent };